import { weightConstants } from "../../constants";
import { weightService } from "../../services";
import { alertActions } from "../alert.actions";

export const weightActions = {
  getSingleParameter,
  getAllParameters,
  addParameter,
  updateParameter,
  deleteParameter,
  clear,
};

// get single parameter
function getSingleParameter() {}

// get all parameter
function getAllParameters() {
  return (dispatch) => {
    dispatch(request());

    weightService.getAllParameters().then(
      (items) => dispatch(success(items)),
      (error) => dispatch(failure(error))
    );
  };

  function request(params) {
    return { type: weightConstants.GET_ALL_REQUEST, params };
  }
  function success(items) {
    return { type: weightConstants.GET_ALL_SUCCESS, items };
  }
  function failure(error) {
    return { type: weightConstants.GET_ALL_FAILURE, error };
  }
}

// add parameter
function addParameter(count, max_limit, cost) {
  return (dispatch) => {
    dispatch(request(count, max_limit, cost));

    weightService.addParameter(count, max_limit, cost).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: weightConstants.ADD_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: weightConstants.ADD_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: weightConstants.ADD_FAILURE, error };
  }
}

// update parameter
function updateParameter(id, count, max_limit, cost) {
  return (dispatch) => {
    dispatch(request(id, count, max_limit, cost));

    weightService.updateParameter(id, count, max_limit, cost).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: weightConstants.UPDATE_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: weightConstants.UPDATE_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: weightConstants.UPDATE_FAILURE, error };
  }
}

// delete parameter
function deleteParameter(id) {
  return (dispatch) => {
    dispatch(request(id));

    weightService.deleteParameter(id).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: weightConstants.DELETE_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: weightConstants.DELETE_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: weightConstants.DELETE_FAILURE, error };
  }
}

// clear parameter
function clear() {
  return { type: weightConstants.CLEAR };
}
